import React, { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import AdviceToTourist from "components/AdviceToTourist"
import { useTranslation } from "react-i18next"
import { adcivesFor } from "./helper"
import { useShowAlert } from "hooks/customAlert"
import visitor from "services/visitor"
import { useDispatch } from "react-redux"
import FullScreen from "components/Spinner/FullScreen"
import { fetchUserCreditionals } from "redux/modules/userDatas/actions"
import UserDatasCarousel from "components/Carousel/UserDatasCarousel"
import Empty from "components/Empty"
import MapCards from "components/Cards/MapCards"
import ViewCardsSlider from "components/Carousel/ViewCardsSlider"
import { classNames } from "utils/classNames"
import L from "leaflet"
import { FiArrowLeft } from "react-icons/fi"

export default () => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const [cardData, setCardData] = useState([])
  const [refresh, setRefresh] = useState(false)
  const [spinner, setSpinner] = useState(false)
  const [userLocation, setlUserLocation] = useState({})

  const navigate = useNavigate()
  const { error } = useShowAlert()
  // const { token } = useSelector(state => state.userDatasReducer);
  // const { _id: visitorId } = jwtDecode(token);

  const fetchData = () => {
    const postData = {
      page: 1,
      limit: 1000,
      selected: "selected",
    }
    setSpinner(true)

    visitor
      .getVisitorDatas(postData)
      .then((res) => {
        setCardData(res.docs)
      })
      .catch((err) => console.log(err))
      .finally(() => setSpinner(false))
  }

  useEffect(() => {
    navigator.geolocation.getCurrentPosition((position) => {
      const latlng = new L.LatLng(
        parseFloat(position.coords?.latitude),
        parseFloat(position.coords?.longitude)
      )
      setlUserLocation(latlng)
    })
    fetchData()
  }, [refresh])

  const handleDelete = (id) => {
    const deleteData = { selected: id }
    visitor
      .workDelete(deleteData)
      .then(() => {
        dispatch(fetchUserCreditionals())
        setRefresh(!refresh)
      })
      .catch((res) => console.log(res))
  }

  // const handleClick = () => {
  //   alert("Map is opening !")
  // }

  const handleCardClickRoute = (data) => {
    if (
      Object.keys(userLocation)?.length &&
      data.media[0]?.lat &&
      data.media[0]?.lng
    ) {
      window.open(
        `https://www.google.com/maps/dir/${userLocation?.lat},${userLocation?.lng}/${data.media[0]?.lat},${data.media[0]?.lng}/@40.8519793,69.3912986,8z/data=!3m1!4b1!4m2!4m1!3e0`
      )
    } else {
      error(t("error-route"))
    }
  }

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0 })
  }, [])

  if (spinner) {
    return <FullScreen />
  }

  return (
    <div className="text-black">
      <div className="flex items-center justify-between">
        <div className="flex items-center justify-between gap-1">
          <button
            onClick={() => navigate(-1)}
            className="flex items-center justify-start text-base"
          >
            <FiArrowLeft size={25} />
          </button>
          <span className="ml-5 text-xl font-medium">
            {t("placesYouLiked")}
          </span>
        </div>
      </div>
      <div className="md:hidden">
        <UserDatasCarousel
          FullImage
          setRefresh={setRefresh}
          xButton
          handleDelete={handleDelete}
          data={cardData}
        />
      </div>
      <div className="justify-center hidden mt-10 md:flex">
        <div
          className={`flex ${classNames(
            cardData?.length ? "justify-start" : "justify-center"
          )} gap-5 flex-wrap w-full items-start`}
        >
          {cardData?.length ? (
            cardData?.map((item, indx) => {
              return (
                <MapCards
                  xButton
                  handleDelete={handleDelete}
                  setLoading={setSpinner}
                  setRefresh={setRefresh}
                  data={item}
                  key={`${indx * 2}`}
                  onClick={() => handleCardClickRoute(item)}
                />
              )
            })
          ) : (
            <div className="col-span-5 row-span-2 h-[70vh] flex justify-center items-center">
              <Empty message="not-found-text" />
            </div>
          )}
        </div>
        <div className="relative hidden px-1 lg:block md:w-4/12 xl:w-3/12">
          <AdviceToTourist
            title={`${t("advicesForTourist")}`}
            adcivesFor={adcivesFor}
          />
        </div>
      </div>
      <div>
        <ViewCardsSlider
          refresh={refresh}
          setRefresh={setRefresh}
          setLoading={setSpinner}
        />
      </div>
    </div>
  )
}
